<template>
  <div>
    <el-badge :value="alertCount">
      <el-button size="mini" type="text" style="padding: 0 !important; font-size: 1.5rem; color: orange"
        @click="showModal = true">
        <i class="fa-solid fa-timeline"></i>
      </el-button>
    </el-badge>

    <el-dialog :title="$t('Hadisə_statusları_və_qeydləri')" :visible.sync="showModal" width="60%" top="5vh" append-to-body>
      <accident-status :type="computedType" :id="computedId" @noteStatusUpdated="fetchAlertCount" />
    </el-dialog>
  </div>
</template>
<script>
import AccidentStatus from "../components/AccidentStatus.vue";
import { NotesStatusCount } from "../../services/common";

export default {
  components: {
    AccidentStatus,
  },
  props: {
    accidentId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      alertCount: 0,
    };
  },
  computed: {
    computedType() {
      const pathParts = this.$route.path.split("/");
      return pathParts.includes("claim") ? "claim" : "accident";
    },
    computedId() {
      const pathParts = this.$route.path.split("/");
      const typeIndex = pathParts.findIndex((part) => part === "claim" || part === "accident");
      if (typeIndex !== -1 && pathParts[typeIndex + 1]) {
        return Number(pathParts[typeIndex + 1]) || null;
      }
      return null;
    },
  },
  methods: {
    fetchAlertCount() {
      const type = this.computedType;
      const id = this.computedId;

      if (!type || !id) {
        this.alertCount = 0;
        return;
      }

      NotesStatusCount(type, id)
        .then((response) => {
          if (response.data) {
            this.alertCount = response.data;
          } else {
            this.alertCount = 0;
          }
        })
        .catch((error) => {
          this.alertCount = 0;
        });
    }
  },
  watch: {
    computedType: "fetchAlertCount",
    computedId: "fetchAlertCount",
  },
  mounted() {
    this.fetchAlertCount();
  },
};
</script>
